import React from 'react';
import PropTypes from 'prop-types';
import figureBlue from '../../../assets/images/icons/figure_blue.svg';
import figurePurple from '../../../assets/images/icons/figure_purple.svg';
import figureGrey from '../../../assets/images/icons/figure_grey.svg';

export const SubsequentCareFigures = ({invasive, conservative}) => {
  const aryImg = [];
  const conservativeFig = parseInt(conservative, 10);
  const invasiveFig = parseInt(invasive, 10);

  for (let i = 0; i < conservativeFig; i++) {
    aryImg.push(figureBlue);
  }

  for (let i = 0; i < invasiveFig - conservativeFig; i++) {
    aryImg.push(figurePurple);
  }

  if (invasiveFig === 0) {
    for (let k = 0; k < 100 - conservativeFig; k++) {
      aryImg.push(figureGrey);
    }
  }
  else {
    for (let k = 0; k < 100 - invasiveFig; k++) {
      aryImg.push(figureGrey);
    }
  }

  return (
    <div>
      {aryImg.map((ele, idx) =>
        // eslint-disable-next-line react/no-array-index-key
        <span key={idx}>
          <img
            alt='Icon image'
            className='figure-style'
            src={ele}/>
          {(idx + 1) % 10 === 0 && <br/>}
        </span>)}
    </div>
  );
};

SubsequentCareFigures.propTypes = {
  conservative: PropTypes.number.isRequired,
  invasive: PropTypes.number.isRequired
};
